import React from "react";
import Footer from "../../component/common/footer";
import SEO from "../../component/util/SEO";
import "./privacy.css";

function PrivacyPolicy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="BringIt Go privacy policy covering personal data, cookies, analytics consent, and UK/EU GDPR rights."
        canonical="https://www.bringitgo.tech/privacy"
        keywords="BringIt Go privacy policy, analytics consent, UK GDPR"
      />
      <main className="privacy-page">
        <section className="privacy-hero" aria-labelledby="privacy-heading">
          <p className="privacy-kicker">Privacy Policy</p>
          <h1 id="privacy-heading">How BringIt Go handles your data</h1>
          <p>
            This policy explains what personal information we collect, why we
            collect it, how cookies and analytics work, and the rights available
            to visitors in the UK, European Economic Area, and other regions
            with data protection laws.
          </p>
          <span>Last updated: 1 May 2026</span>
        </section>

        <section className="privacy-content" aria-label="Privacy policy">
          <article>
            <h2>Who we are</h2>
            <p>
              BringIt Go provides web development, design, cloud, blockchain,
              and related technology services. For privacy questions, contact us
              at <a href="mailto:info@bringitgo.tech">info@bringitgo.tech</a>.
            </p>
          </article>

          <article>
            <h2>Information we collect</h2>
            <p>
              We may collect information you submit through our contact forms or
              direct communications, such as your name, email address, phone
              number, company details, project requirements, and message
              content.
            </p>
            <p>
              If you accept analytics cookies, we also collect limited website
              usage data through Google Analytics, such as page views, device
              type, browser information, approximate location, referral source,
              and interactions with the site.
            </p>
          </article>

          <article>
            <h2>How we use information</h2>
            <p>
              We use personal information to respond to enquiries, provide
              quotes, deliver services, manage client relationships, improve our
              website, protect the security of our services, and meet legal or
              regulatory obligations.
            </p>
          </article>

          <article>
            <h2>Legal basis for processing</h2>
            <p>
              Where UK GDPR or EU GDPR applies, we process personal data under
              one or more lawful bases: your consent for optional analytics
              cookies, performance of a contract or steps before a contract when
              you enquire about our services, legitimate interests in operating
              and improving our business, and legal obligations where required.
            </p>
          </article>

          <article>
            <h2>Cookies and analytics consent</h2>
            <p>
              Essential site functionality may use strictly necessary cookies.
              Google Analytics is optional and is not activated unless you click
              “Accept All” on the cookie banner. If you decline, analytics
              tracking remains disabled.
            </p>
            <p>
              You can change your choice by clearing this site’s cookies in your
              browser and revisiting the website. Browser privacy settings and
              extensions may also block analytics.
            </p>
          </article>

          <article>
            <h2>Sharing and international transfers</h2>
            <p>
              We do not sell personal information. We may share data with
              trusted service providers who help us operate the website, process
              enquiries, provide hosting, analytics, communications, or business
              support. Some providers may process data outside your country; in
              those cases we rely on appropriate safeguards where required by
              law.
            </p>
          </article>

          <article>
            <h2>Retention</h2>
            <p>
              We keep personal data only for as long as needed for the purposes
              described in this policy, including responding to enquiries,
              delivering services, maintaining business records, resolving
              disputes, and meeting legal obligations.
            </p>
          </article>

          <article>
            <h2>Your rights</h2>
            <p>
              Depending on your location, you may have rights to access,
              correct, delete, restrict, object to, or receive a copy of your
              personal data. You may also withdraw consent where processing is
              based on consent.
            </p>
            <p>
              UK visitors can raise concerns with the Information Commissioner’s
              Office. EU/EEA visitors may contact their local supervisory
              authority. We encourage you to contact us first so we can try to
              resolve the issue.
            </p>
          </article>

          <article>
            <h2>Contact</h2>
            <p>
              To exercise privacy rights or ask questions about this policy,
              email <a href="mailto:info@bringitgo.tech">info@bringitgo.tech</a>.
            </p>
          </article>
        </section>
      </main>
    </>
  );
}

export default PrivacyPolicy;
